// extracted by mini-css-extract-plugin
export default {"container":"ToggleButton_container__JBaH-","wrapper":"ToggleButton_wrapper__dRvz2","on":"ToggleButton_on__WT00P","circle":"ToggleButton_circle__8E6YB"};